module.exports = "build/assets/RingsideWide-Bold.4811a121.woff";